import { createSlice } from '@reduxjs/toolkit'
import { deleteOriginalAuth, setOriginalAuth, setTokens } from '../reducers/authReducers'

export type AuthState = {
  idToken: string
  accessToken: string
  accessTokenExpiration: number
  refreshToken: string
  refreshTokenExpiration: number
  originalAuth?: {
    idToken: string
    refreshToken: string
  }
}

const initialState: AuthState = {
  idToken: '',
  accessToken: '',
  accessTokenExpiration: 0,
  refreshToken: '',
  refreshTokenExpiration: 0,
}

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setTokens,
    setOriginalAuth,
    deleteOriginalAuth,
  },
})

export const authActions = authSlice.actions
export default authSlice.reducer
